module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("PCS 04 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Interface Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "interfaceName",
      "name": "interfaceName"
    },
    model: {
      value: (_vm.interfaceName),
      callback: function($$v) {
        _vm.interfaceName = $$v
      },
      expression: "interfaceName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BOE Number (2159404)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "boeNumber",
      "name": "boeNumber"
    },
    model: {
      value: (_vm.boeNumber),
      callback: function($$v) {
        _vm.boeNumber = $$v
      },
      expression: "boeNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.interfaceName && _vm.boeNumber) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPCS04Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.getAllPcs04 ||
    !_vm.getAllPcs04[0] ||
    _vm.getAllPcs04[0].response[0].responseMsg === 'not found'
  ) ? _c('div', [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v("No data found.")])]) : _c('div', [(_vm.getAllPcs04.length > 0) ? _c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Igm No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_IgmNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Bill Of Entry Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_BillOfEntryDate || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Subline No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].sublineNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Nature of Cargo:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].natureOfCargo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Igm Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_IgmDate || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Sub Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_sub_line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Igm Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].igmDate || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Number of Packages:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].numberOfPackages || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Sub Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].sub_line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Gross Weight:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].grossWeight || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Line No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].lineNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Custom House Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].customHouseCode || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Bill Of Entry No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].billOfEntryNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Container No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].container_no || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Country Of Origin:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].countryOfOrigin || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_line_number || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("CHA Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].chaCode || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Unit Of Quantity:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].unitOfQuantity || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Items Bill Of Entry No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].items_BillOfEntryNo || "N/A") + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Bill Of Entry Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs04[0].response[0].billOfEntryDate || "N/A") + "\n        ")])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cee69922","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/PCS04_ResponseDisplay.vue
// module id = 2865
// module chunks = 0